import { MATRIX_BACKEND } from '@/remotes';
import { defineStore } from 'pinia';

export const useNewDataFormCalculateCargoPickUpStore = defineStore({
  id: 'newDataFormCalculateCargoPickUpStore',
  state: () => ({
    calculatedData: {
      totalVolume: 0,
      totalWeight: 0,
      totalCargoCount: 0,
      indexLess: 0,
      cargoSpaceCosts: [
        {
          cargoType: 0,
          volume: 0,
          weight: 0,
          package: 0,
          warmPlace: 0,
        },
      ],
      shippingCost: {
        transportation: 0,
        cargoPickUp: 0,
        extraChargeForCargoPickUp: 0,
        cargoDelivery: 0,
        extraChargeForCargoDelivery: 0,
        package: 0,
        warmPlace: 0,
        cashOnDeliveryAmount: 0,
        costForTheRedemptionOfCargo: 0,
        costWarranty: 0,
        costForReturningDocuments: 0,
        costForWaitingOnPickUp: 0,
        costForWaitingOnDelivery: 0,
        total: 0,
      },
      calcInd: 0,
      baseIndex: 0,
      sog: 0,
    },
    error: false,
    loading: false,
  }),

  actions: {
    async fetchDataForCalculator(bodyCalc) {
      try {
        this.loading = true;
        const { data } = await MATRIX_BACKEND.post(`/api/public/calculator`, bodyCalc);
        this.calculatedData = data;
      } catch (error) {
        this.error = true;
        this.$reset();
      } finally {
        this.loading = false;
      }
    },
  },
});
